import React from 'react';
import Button from '../../buttons/Button';
import { Text, Heading } from '../../typography';
import { Block, ButtonLink, Container, Content } from './CrawfordsFarmHeader.style.pn';

interface CrawfordsFarmHeaderProps {}

const CrawfordsFarmHeader: React.FC<CrawfordsFarmHeaderProps> = () => {
  return (
    <Container data-testid="crawfords-farm-header">
      <Block>
        <Text as="h3" fontSize={21} textTransform="uppercase" fontWeight="bold">
          Coastal & Country Living
        </Text>
        <Text fontSize={17}>New Phase Now on Release</Text>
      </Block>
      <Content>
        <Heading fontSize={36} mb={8} align="center">
          Crawfords Farm
        </Heading>
        <Text fontWeight="bold" textTransform="uppercase">
          <Text as="span" fontWeight="400">
            Crawfordsburn Road,
          </Text>
          <span> Bangor West, BT19 1BZ</span>
        </Text>
      </Content>
      <ButtonLink href={`/search?term=${encodeURIComponent(`Crawfords Farm Development Bangor`)}`} prefetch={false}>
        <Button type="button" color="#D3B666" maxWidth="150px">
          View Properties
        </Button>
      </ButtonLink>
    </Container>
  );
};

export default CrawfordsFarmHeader;
